const KEYS_TO_KEEP = [
  'searchedAddress',
  'lastTransaction',
  'firstTransaction',
  'counterPartySummary',
  'sankey',
];

/**
 * Process full wallet profile
 * @param {Array} walletData - Array of JSON file objects
 * @param {string} input - User input text
 * @param {Array} uploadedImages - Uploaded images
 * @returns {Object} - Object containing processed JSON files and messages
 */
export const processFullWalletProfile = (walletData, input, uploadedImages) => {
  // Deep clone the wallet data to avoid modifying the original object
  const wallet = JSON.parse(JSON.stringify(walletData[0].data));

  // Remove unnecessary keys
  for (const key in wallet) {
    if (!KEYS_TO_KEEP.includes(key)) {
      delete wallet[key];
    }
  }

  // create a string for context. Each key and then the value on a new line for all the keys

  let context = '';

  for (const key in wallet) {
    context += `Detailed ${key} data:\n`;
    context += JSON.stringify(wallet[key], null, 2);
    context += '\n';
  }

  // Create first system message with original JSON data
  const systemDataMessage = {
    role: 'user',
    content: `
      Instructions:
      
      Analyze this Blockscope Wallet Profile data and provide a detailed analysis of the wallet profile.
  
      ${context}
      `,
  };

  // Create user message
  const userMessage = {
    role: 'user',
    content: [
      {
        type: 'text',
        text: input, // inputmessage is fetched from actionplan default
      },
      ...(uploadedImages
        ? uploadedImages.map((m) => ({ type: 'image', image: m[0] }))
        : []),
    ],
  };

  return {
    messages: {
      dataMessages: [systemDataMessage],
      userMessage,
    },
  };
};

